module.exports = function getResource(label, vars = []) {
    let resources = {
        allStores: 'Tous les magasins',
        chooseLocation: 'Choisir un lieu'
    };
    return resources[label];
};
